// MessageHeader.jsx

import React from 'react';

// CSS
import './MessageHeader.css';

/**
 * MessageHeader
 *
 * @returns {ReactNode} The rendered component.
 */
const MessageHeader = React.memo(({
  displayName,
  createdLabel,
  edited,
  deleted,
  theme,
}) => {

  // ----- RENDER ----- //

  return (

  <div className="message-header-row">

    {/* MESSAGE AUTHOR */}
    <span
      className="message-author"
    >{displayName}</span>
    <span
      className="message-time"
    >{createdLabel}</span>

    {/* MESSAGE EDITED */}
    {edited && !deleted ? (
      <span
        className="message-edited"
      >(edited)</span>
    ) : null}
  </div>
);
});

// Dev Tools
MessageHeader.displayName = 'MessageHeader';

export default MessageHeader;
